import ClientRepository from "@domain/repositories/ClientRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";

type Input = Client["id"];

type Output = Promise<void>;

export class RemoveClientFromMapUseCase implements UseCase<Input, Output> {
  constructor(private readonly clientRepository: ClientRepository) {
    this.clientRepository = clientRepository;
  }

  async execute(clientId: Input) {
    return this.clientRepository.updateStatus(clientId);
  }
}
